// src/components/nodes/NoteNode.js
import { NodeBase } from './NodeBase';

export class NoteNode extends NodeBase {
  constructor() {
    super('note', { 
      text: '这里是注释内容，用于说明流程的注意事项...'
    });
  }

  renderContent(data, selected) {
    return (
      <div className="note-content">
        <div className="note-text">
          {data.text || '注释内容...'}
        </div>
      </div>
    );
  }

  getConfig() {
    return {
      type: this.type,
      label: '注释节点',
      icon: '💡',
      defaultData: this.defaultData
    };
  }
}